import { useCallback } from 'react';
import {
  SuccessCallback,
  useActionPipeline,
  useDialogState,
  useToast,
} from 'hooks';
import { useIntl } from 'react-intl';
import { commonTexts } from 'i18n';
import { changeStatus } from 'store/scorecards';
import { SCORECARD_ACTION_ASSESSMENT_STOPPED } from 'constants/scorecards';
import { useScorecardContext } from 'contexts';

export default function useStopFeedbackGathering() {
  const { id, store } = useScorecardContext();
  const [
    isStopFeedbackGatheringDialogActive,
    openStopFeedbackGatheringDialog,
    onStopFeedbackGatheringDialogClose,
  ] = useDialogState();

  const onStopFeedbackGatheringClick = useCallback(() => {
    openStopFeedbackGatheringDialog();
  }, [openStopFeedbackGatheringDialog]);

  const { formatMessage } = useIntl();
  const showMessage = useToast();
  const onStopFeedbackGatheringSuccess = useCallback<SuccessCallback>(() => {
    showMessage({
      severity: 'success',
      message: formatMessage(commonTexts.success),
    });
  }, [showMessage, formatMessage]);

  const stopFeedbackGatheringPipeline = useActionPipeline(
    onStopFeedbackGatheringSuccess,
    null,
    onStopFeedbackGatheringDialogClose,
  );

  const onStopFeedbackGatheringSubmit = useCallback(() => {
    stopFeedbackGatheringPipeline(
      changeStatus({ id, store, action: SCORECARD_ACTION_ASSESSMENT_STOPPED }),
    );
  }, [id, stopFeedbackGatheringPipeline, store]);

  return {
    onStopFeedbackGatheringClick,
    isStopFeedbackGatheringDialogActive,
    onStopFeedbackGatheringDialogClose,
    onStopFeedbackGatheringSubmit,
  };
}
